<template>
  <div>
    <v-layout column style="height: 90vh">      
    <v-flex md6 style="overflow: auto">
      <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="Buscar"
      single-line
      hide-details
      class="mx-5 mb-3"
    ></v-text-field>
    <v-data-table
      :headers="headers"
      :items="data"
      :search="search"
      :items-per-page="10"
      :footer-props="{
        'items-per-page-text': 'Elementos por página',
        'items-per-page-all-text': 'Todo',
      }"
      no-results-text="Sin resultados coincidentes con la búsqueda"
      loading-text="Cargando..."
      no-data-text="Sin resultados disponibles"
      dense
      fixed-header
      height="auto"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn @click="accion(), getClinicHistory(item)" icon>
              <v-icon :color="icono.color" v-bind="attrs" v-on="on">
                {{ icono.icon }}
              </v-icon>
            </v-btn>
          </template>
          <span>{{ icono.tooltip }}</span>
        </v-tooltip>
      </template>
    </v-data-table>
    </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "Datatable",
  props: {
    headers: Array,
    data: Array,
    search: String,
    icono: Object,
  },
  methods: {
    accion() {
      this.$emit("showModal");
    },
    getClinicHistory(item) {
      let postData = {
        idPatient: item.id,
      };
      const historial = axios
        .post(
          "http://192.168.1.101:8084/ws-sitdris/patient/findClinicHistory",
          postData
        )
        .then((res) => {
          if (res.data.clinicHistory) {
            let objPaciente = res.data.clinicHistory;
            this.$emit("historia", objPaciente);
          }
        });
    },
  },
};
</script>
